import React, { useEffect, useState } from "react";

import { api } from "../api";
import { API_Compo } from "../../../src/apidefs";
import { CompoCard } from "../DesignSystem/CompoCard";

export function AllComposList() {
  const [compos, setCompos] = useState<API_Compo>([]);

  useEffect(() => {
    api.get("/api/compo").then(setCompos);
  }, []);

  return (
    <div className="space-y-6">
      {compos.map(({ compo, entries, entryCount }) => (
        <CompoCard
          key={compo.id}
          compo={compo}
          entries={entries}
          entryCount={entryCount}
        />
      ))}
    </div>
  );
}

export function AllComposPage() {
  return (
    <div className="min-h-screen bg-slate-100 text-slate-900 dark:bg-slate-900 dark:text-white">
      <div className="mx-auto max-w-4xl px-5 py-8 sm:px-10">
        <h2 className="mb-6 text-2xl font-bold text-slate-900 dark:text-white">
          All Compos
        </h2>

        <AllComposList />
      </div>
    </div>
  );
}
